<div class="confirmation-dialog">
  <div class="dialog-header">
    <div class="icon-wrapper warning">
      <i class="fas fa-exclamation-triangle"></i>
    </div>
    <h2 mat-dialog-title>{{ data.title }}</h2>
  </div>
  <mat-dialog-content>
    <p>{{ data.message }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" class="cancel-btn">
      <span>{{ data.cancelText }}</span>
    </button>
    <button mat-button (click)="onConfirm()" class="confirm-btn">
      <span>{{ data.confirmText }}</span>
    </button>
  </mat-dialog-actions>
</div>

